import { useState, useEffect } from "react"
import { formatDistanceToNowStrict, isToday, isYesterday, format, differenceInDays } from "date-fns"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

function formatCreatedAt(date) {
  const created = new Date(date)
  const now = new Date()

  if (isToday(created)) {
    return "today"
  }

  if (isYesterday(created)) {
    return "yesterday"
  }

  const daysDiff = differenceInDays(now, created)

  // Within the last week - show "last Tuesday" etc.
  if (daysDiff < 7) {
    const dayName = format(created, "EEEE")
    return `last ${dayName}`
  }

  // Over a week - show the actual date
  const sameYear = created.getFullYear() === now.getFullYear()
  return format(created, sameYear ? "MMM d" : "MMM d, yyyy")
}

function formatUpdatedAt(date) {
  return formatDistanceToNowStrict(new Date(date), { addSuffix: true })
}

function formatExactDateTime(date) {
  return format(new Date(date), "EEE, MMM d, yyyy 'at' h:mm a")
}

export function RelativeTime({ createdAt, updatedAt }) {
  const [, setTick] = useState(0)

  // Update every minute for real-time feel
  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 60000)
    return () => clearInterval(interval)
  }, [])

  const createdFormatted = formatCreatedAt(createdAt)
  const updatedFormatted = formatUpdatedAt(updatedAt)

  return (
    <p className="text-sm text-muted-foreground">
      Created{" "}
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{createdFormatted}</span>
        </TooltipTrigger>
        <TooltipContent>{formatExactDateTime(createdAt)}</TooltipContent>
      </Tooltip>
      {" "}<span className="text-slate-300 px-0.5">&bull;</span>{" "}
      Last updated{" "}
      <Tooltip>
        <TooltipTrigger asChild>
          <span>{updatedFormatted}</span>
        </TooltipTrigger>
        <TooltipContent>{formatExactDateTime(updatedAt)}</TooltipContent>
      </Tooltip>
    </p>
  )
}
